import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { partnerDashboardAPI } from '../../services/partnerApi';

const PartnerProtectedRoute = ({ children }) => {
  const [authState, setAuthState] = useState({
    checking: true,
    isAuthenticated: false,
    onboardingStatus: null,
    dashboardBypassAllowed: false
  });
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const checkAuth = async () => {
      try {
        const response = await partnerDashboardAPI.getOnboardingStatus();
        const data = response?.data?.data || {};
        if (isMounted) {
          setAuthState({
            checking: false,
            isAuthenticated: true,
            onboardingStatus: data.onboardingStatus || 'PENDING_AGREEMENT',
            dashboardBypassAllowed: !!data.dashboardBypassAllowed
          });
        }
      } catch (error) {
        if (isMounted) {
          localStorage.removeItem('partnerUser');
          setAuthState({
            checking: false,
            isAuthenticated: false,
            onboardingStatus: null,
            dashboardBypassAllowed: false
          });
        }
      }
    };

    checkAuth();
    return () => { isMounted = false; };
  }, [location.pathname]);

  if (authState.checking) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f4f6f8' }}>
        <CircularProgress sx={{ color: '#163300' }} />
      </Box>
    );
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/partner/login" state={{ from: location }} replace />;
  }

  const isComplete = authState.onboardingStatus === 'COMPLETE' || authState.dashboardBypassAllowed;
  const isOnboardingPath = location.pathname.startsWith('/partner/onboarding');

  // If onboarding is NOT complete, enforce redirect to /partner/onboarding
  if (!isComplete && !isOnboardingPath) {
    return <Navigate to="/partner/onboarding" replace />;
  }

  // If onboarding IS complete, don't linger on /partner/onboarding
  if (isComplete && isOnboardingPath) {
    return <Navigate to="/partner/dashboard" replace />;
  }

  return children ?? <Outlet />;
};

export default PartnerProtectedRoute;
